import './ConfirmModal.css';

export default function ConfirmModal({ isOpen, onConfirm, onCancel, title, message, confirmText, confirmClass }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-glass" onClick={e => e.stopPropagation()}>

        {/* Icon */}
        <div className="modal-icon">✓</div>

        {/* Text */}
        <h3 className="modal-title">{title}</h3>
        <p className="modal-message">{message}</p>

        {/* Actions */}
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className={'btn ' + (confirmClass || 'btn-primary')} onClick={onConfirm}>
            {confirmText || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}